<template>
  <div class="create-consultation-wrapper">
    <div class="prescription-creation-section">
      <button @click="toggleDropdown" class="create-prescription-button">
        <i class="fas fa-plus-circle"></i> Create Weight Prescription
      </button>

      <div v-if="dropdownOpen" class="create-consultation-dropdown">
        <button @click="selectDrug('Semaglutide')" class="dropdown-item-button">Semaglutide</button>
        <button @click="selectDrug('Tirzepatide')" class="dropdown-item-button">Tirzepatide</button>
      </div>
    </div>

    <div v-if="loading" class="loading-indicator">
      <p>Creating prescription...</p>
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div v-if="creationError" class="formError">
      {{ creationError }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    consultationId: {
      type: Number,
    }
  },
  data() {
    return {
      dropdownOpen: false,
      loading: false,
      creationError: null,
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      if (this.dropdownOpen) {
        this.creationError = null;
      }
    },
    selectDrug(drug) {
      this.dropdownOpen = false;
      this.createPrescription(drug);
    },
    handleClickOutside(event) {
      if (this.dropdownOpen && !this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
    createPrescription(drugName) {
      this.loading = true;
      this.creationError = null;

      axios.post('/api/v1/consultation/store', {
        drugName: drugName,
        consultationId: this.consultationId,
      })
        .then(response => {
          location.reload();
        })
        .catch(error => {
          this.creationError = 'Failed to create prescription. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            this.creationError = error.response.data.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.create-consultation-wrapper {
  display: inline-block;
  position: relative;
}

.prescription-creation-section {
  position: relative;
  display: inline-block;
}

.create-prescription-button {
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  background: #00263f;
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.create-prescription-button:hover {
  background-color: #00263f;
}

.create-consultation-dropdown {
  position: absolute;
  background-color: white;
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1000;
  border: 1px solid #ddd;
  border-radius: 4px;
  top: 100%;
  left: 0;
  margin-top: 5px;
  padding: 0;
}

.dropdown-item-button {
  background: none;
  border: none;
  outline: none;
  color: #333;
  padding: 12px 16px;
  text-align: left;
  text-decoration: none;
  display: block;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item-button:hover {
  background-color: #f1f1f1;
  color: #333;
}

.loading-indicator {
  margin-top: 15px;
  color: #00263f;
  display: flex;
  align-items: center;
  gap: 8px;
}

.formError {
  color: red;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/CreateConsultation.vue